// @flow
const account = 'https://meinereisen.test.meinschiff.com';
export default {
  trackingCode: 'qa', // 'UA-6438006-17',
  cookieDomain: '.meinschiff.com',
  logoutURL: 'https://meinereise.test.meinschiff.com/login',
  account,
  accountLogin: `${account}/signin`,
  accountRegister: `${account}/signin/registration`,
  excursionMultiSelectCacheKey: 'travelPartyState',
  iadvizeId: '6761',
};
